export const version = 'kunde-v1.20.0-SNAPSHOT-ab1689cab75b7ad964a27dd6ec31dc57299f9c80';